import { call, put, takeEvery } from "redux-saga/effects";
import {
  createHeaderRequest,
  createHeaderSuccess,
  createHeaderFailure,
} from "../slice/renameTitleSlice";
import { updateTiteSession } from "../../api/apiService";
import { getApiError } from "@src/utils/apiError";

interface CreateHeaderRequest {
    id: string;              // header parameter
    body: {
      header: string;
    };
  }

export function* renameSaga(
  action: { payload: CreateHeaderRequest }
): Generator<any, void, any> {
  try {
    const response = yield call(updateTiteSession, action.payload);
    yield put(createHeaderSuccess(response.data));
  } catch (error: unknown) {
    const apiError = getApiError(error);
    yield put(
        createHeaderFailure(
            apiError.message
        )
    );
}
}

export function* renameTitleSaga() {
  yield takeEvery(createHeaderRequest, renameSaga);
}
